import React from "react";
import { Check, X, TriangleAlert } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const comparisonData = [{
  id: 1,
  feature: "Unificación de canales",
  omniText: "Sí",
  omniType: "check",
  tradText: "No",
  tradType: "cross"
}, {
  id: 2,
  feature: "Automatización con IA",
  omniText: "Sí",
  omniType: "check",
  tradText: "Limitada",
  tradType: "warning"
}, {
  id: 3,
  feature: "Reportes en tiempo real",
  omniText: "Sí",
  omniType: "check",
  tradText: "No",
  tradType: "cross"
}, {
  id: 4,
  feature: "Integraciones con CRM",
  omniText: "Sí",
  omniType: "check",
  tradText: "Opcional",
  tradType: "warning"
}, {
  id: 5,
  feature: "Escalabilidad",
  omniText: "Alta",
  omniType: "check",
  tradText: "Baja",
  tradType: "cross"
}];
export default function ChatComparison() {
  const renderIcon = (type: string) => {
    switch (type) {
      case "check":
        return <div className="bg-chart-3 text-white rounded-sm size-4 flex items-center justify-center shrink-0">
            <Check className="size-3" strokeWidth={4} />
          </div>;
      case "cross":
        return <X className="size-4 text-destructive shrink-0" strokeWidth={3} />;
      case "warning":
        return <TriangleAlert className="size-4 text-primary shrink-0" strokeWidth={2.5} />;
      default:
        return null;
    }
  };
  return <section id="chatcomparison" className="relative w-full bg-background py-10 md:py-14 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none flex justify-center items-center opacity-30">
        <div className="w-[800px] h-[400px] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-accent via-background to-background rounded-lg blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-primary text-center mb-10 font-default">
            ¡Compare y defina usted mismo cuál es la mejor opción!
          </h2>

          <div className="bg-card rounded-xl shadow-lg border border-border overflow-hidden">
            <Table>
              <TableHeader>
                <TableRow className="hover:bg-transparent border-b border-border">
                  <TableHead className="w-1/3 text-center font-bold text-primary text-base py-4 border-r border-border">
                    Funcionalidad
                  </TableHead>
                  <TableHead className="w-1/3 text-center font-bold text-primary text-base py-4 border-r border-border">
                    Chat Omnicanal
                  </TableHead>
                  <TableHead className="w-1/3 text-center font-bold text-primary text-base py-4">
                    Chat Tradicional
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {comparisonData.map((row, i) => <TableRow key={row.id} data-index={i} className="even:bg-accent/40 hover:bg-accent/60 transition-colors border-b border-border last:border-0">
                    <TableCell className="py-4 px-6 text-primary/90 font-medium border-r border-border text-center md:text-left">
                      {row.feature}
                    </TableCell>
                    <TableCell className="py-4 px-6 border-r border-border">
                      <div className="flex items-center justify-center gap-2 text-primary font-medium">
                        {renderIcon(row.omniType)}
                        <span>{row.omniText}</span>
                      </div>
                    </TableCell>
                    <TableCell className="py-4 px-6">
                      <div className="flex items-center justify-center gap-2 text-primary/80 font-medium">
                        {renderIcon(row.tradType)}
                        <span>{row.tradText}</span>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>

          <div className="mt-8 md:mt-10 text-center flex flex-col items-center">
            <h3 className="text-xl md:text-2xl font-semibold text-primary mb-6 font-default">
              Potencie su servicio al cliente hoy mismo.
            </h3>
            <Link to="#">
              <Button size="lg" className="bg-chart-3 hover:bg-chart-3/90 text-white font-semibold text-lg px-8 py-6 shadow-md transition-transform hover:scale-105">
                ¡Contactar un asesor!
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}